import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import 'primeicons/primeicons.css'

import App from './App.vue'
import router from './router'
import i18n, { getCurrentLocale, initLocaleSideEffects } from './i18n'
import { getPrimeVueLocale } from './i18n/primevue-locales'
import '@/assets/styles/main.css'

const app = createApp(App)

// dayjs locale + <html lang> başlangıç değerleri
initLocaleSideEffects()

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E9F5FF',
      100: '#D4EAFC',
      200: '#B8DCF8',
      300: '#93BFEF',
      400: '#6BA8EA',
      500: '#488BE6',
      600: '#2E6DB8',
      700: '#1A5799',
      800: '#0F4378',
      900: '#092F64',
      950: '#051A3A'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f9fafb',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#374151',
          800: '#1f2937',
          900: '#111827'
        },
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}'
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}'
        }
      },
      dark: {
        surface: {
          0: '#1F1F1F',
          50: '#252525',
          100: '#2e2e2e',
          200: '#3d3d3d',
          300: '#525252',
          400: '#737373',
          500: '#a3a3a3',
          600: '#d4d4d4',
          700: '#e5e5e5',
          800: '#2a2a2a',
          900: '#222222',
          950: '#181818'
        },
        primary: {
          color: '{primary.400}',
          contrastColor: '{surface.0}',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}'
        },
        highlight: {
          background: 'rgba(72, 139, 230, 0.18)',
          focusBackground: 'rgba(72, 139, 230, 0.28)',
          color: 'rgba(255,255,255,.92)',
          focusColor: '#ffffff'
        }
      }
    }
  }
})

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: 'html.dark'
    }
  },
  locale: getPrimeVueLocale(getCurrentLocale()),
})
app.use(ToastService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)

app.mount('#app')
